import { Component } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
@Component({
  selector: 'app-road-coverage-data',
  templateUrl: './road-coverage-data.component.html',
  standalone: false,
})
export class RoadCoverageComponent {
  public layerIds = Layers
  public isRoadCoverageLayerVisible: boolean
  public detailsOpen = false

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers(Layers.RoadCoverage.name)
    const metrics = this.appState.selectMetrics()

    if (layers) {
      this.isRoadCoverageLayerVisible = layers?.some((layer) => layer === Layers.RoadCoverage.name)
    } else {
      this.isRoadCoverageLayerVisible = false
    }
    this.updateQueryParameters()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.RoadCoverage.name:
        this.isRoadCoverageLayerVisible = !this.isRoadCoverageLayerVisible
        break
      default:
        break
    }
    // Ensure detailsOpen is updated after visibility changes
    setTimeout(() => {
      this.detailsOpen = !!this.isRoadCoverageLayerVisible
    })
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter((layer) => !(layer == Layers.RoadCoverage.name))

    if (this.isRoadCoverageLayerVisible) {
      layers.push(Layers.RoadCoverage.name)
    }

    this.appState.setState(AppPaths.Internal, {
      layers: layers?.toString(),
    })
  }

  ngOnInit() {
    const layers = this.appState.selectLayers()
    if (layers) {
      this.isRoadCoverageLayerVisible = layers?.some((layer) => layer === Layers.RoadCoverage.name)
    } else {
      this.isRoadCoverageLayerVisible = false
    }
    this.detailsOpen = !!this.isRoadCoverageLayerVisible
  }
}
